import BodyText from 'LuxKit/Typography/BodyText'
import config from 'constants/config'
import { rem } from 'polished'
import styled from 'styled-components'
import { useIntl } from 'react-intl'

export const FareFamilyDisclaimerContainer = styled.div`
  padding-left: ${rem(8)};
  text-indent: ${rem(-6)};
`

function FareFamilyModalDisclaimer() {
  const intl = useIntl()

  const disclaimerLine1 = intl.formatMessage({
    id: 'O4rFsmRfqOQYOwZAu8Z5',
    defaultMessage: '* Please note change/cancellation fees are based on a ‘Before Departure’ basis and may change once travel has commenced.',
    description: 'Disclaimer about change/cancellation fees being based on pre-departure timing',
  })

  const disclaimerLine2 = intl.formatMessage({
    id: 'h2mpEqZRuQn_QNk_DMNY',
    defaultMessage: 'Please read the ‘Fare Rules’ of your selected flight at the checkout page for full details.',
    description: 'Disclaimer directing users to read fare rules at checkout',
  })

  const disclaimerLine3 = intl.formatMessage({
    id: 'WypmSSk-sLQe8rL7HssF',
    defaultMessage: 'Additional flight change, cancellation or refund fees from {brandName} may apply.',
    description: 'Disclaimer about additional fees from the brand for flight changes',
  }, { brandName: config.title })

  return (
    <BodyText variant="small" colour="light-foreground-alt">
      {disclaimerLine1}
      <br />
      {disclaimerLine2}
      <br />
      {disclaimerLine3}
    </BodyText>
  )
}

export default FareFamilyModalDisclaimer
